// src/pages/messages/relativeTime.js
//
// Relative timestamp formatting for inbox rows. Extracted verbatim from
// InboxV2.jsx so SmsReplyRow can share it without a circular import
// (features/unified-replies/). Behavior unchanged.

import { activeLocale } from '@/utils/formatLocale'

export function fmtRelative(ts) {
  if (!ts) return ''
  const ms = ts.toMillis ? ts.toMillis() : (typeof ts === 'number' ? ts : new Date(ts).getTime())
  const diff = Math.floor((Date.now() - ms) / 1000)
  if (diff < 60) return 'now'
  if (diff < 3600) return `${Math.floor(diff / 60)}m`
  if (diff < 86400) return `${Math.floor(diff / 3600)}h`
  if (diff < 7 * 86400) return `${Math.floor(diff / 86400)}d`
  const d = new Date(ms)
  return d.toLocaleDateString(activeLocale(), { month: 'short', day: 'numeric' })
}
